import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { useAuth } from '../../lib/auth';
import { EVENEMENT_CATEGORIES, fetchCategoriesDepenses } from '../../lib/categoriesDepenses';

export function SelectCategorieDepense({ usage, value = '', children, ...props }) {
  const { user } = useAuth();
  const [etat, setEtat] = useState({ rows: [], charge: false, erreur: false });
  useEffect(() => {
    let vivant = true;
    let sequence = 0;
    const charger = async () => {
      const n = ++sequence;
      try {
        const rows = await fetchCategoriesDepenses({ usage });
        if (vivant && n === sequence) setEtat({ rows, charge: true, erreur: false });
      } catch (e) {
        if (vivant && n === sequence) {
          setEtat({ rows: [], charge: true, erreur: true });
          toast.error(e.message);
        }
      }
    };
    charger();
    window.addEventListener(EVENEMENT_CATEGORIES, charger);
    window.addEventListener('focus', charger);
    return () => {
      vivant = false;
      window.removeEventListener(EVENEMENT_CATEGORIES, charger);
      window.removeEventListener('focus', charger);
    };
  }, [usage, user?.email]);
  const groupes = new Map();
  etat.rows.forEach((c) => groupes.set(c.groupe, [...(groupes.get(c.groupe) ?? []), c]));
  return <select {...props} value={value} disabled={props.disabled || !etat.charge || etat.erreur}>
    {children}
    {!etat.charge && <option disabled value="">Chargement des catégories…</option>}
    {etat.erreur && <option disabled value="">Catégories indisponibles — réessayez</option>}
    {value && !etat.rows.some((c) => c.valeur === value) && (
      <option value={value} disabled>{`${value} (ancienne catégorie)`}</option>
    )}
    {!etat.rows.length && <option disabled value="">Aucune catégorie active</option>}
    {[...groupes].map(([groupe, rows]) => <optgroup key={groupe} label={groupe}>
      {rows.map((c) => <option key={c.id} value={c.valeur}>{c.libelle}</option>)}
    </optgroup>)}
  </select>;
}
